import React from 'react';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { HOST_MEETING_TEXT, JOIN_AS_ATTENDEE, TROUBLESHOOT_TEXT } from '../../../_connections/connections.texts';
import WebinarReportPresentation from '../../webinar-report/webinar-reports.presentation';
import { WebinarReportsViewModel } from '../../webinar-report/webinar-reports.viewmodel';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';


type WebinarConnectionDetailsPopoverContentProps = BaseConnectionDetailsPopoverContentProps & {
    onClickTroubleshoot: () => void;
    webinarReportsVM: WebinarReportsViewModel;
};

export const WebinarConnectionDetailsPopoverContent = (props: WebinarConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onLinkClick, onClickTroubleshoot, webinarReportsVM, onCopyBtnClick } = props;

    const {
        type,
        hostLink,
        cancelled,
        connectionLink,
        connectionId,
        connectionPassword,
        connectionAccount,
        sip,
        registrationUrl
    } = connection;

    const labels = connectionsDetailsLabels();

    const hostManagementPermission = hasPermission(Permission.HOST_MANAGEMENT);
    const zoomWebinarReportPermission = hasPermission(Permission.ZOOM_WEBINAR_REPORT);

    return (
        <>
            <div className='connection-list__header'>
                {hostManagementPermission &&
                    <>
                        <DefaultButton
                            className='prominent-button'
                            disabled={!hostLink || cancelled}
                            text={<FormattedMessage {...HOST_MEETING_TEXT} />}
                            onClick={() => onLinkClick(hostLink)}
                        />
                        <DefaultButton
                            className='small-button silver-button'
                            text={<FormattedMessage{...TROUBLESHOOT_TEXT} />}
                            onClick={onClickTroubleshoot}
                        />
                    </>
                }
                {zoomWebinarReportPermission && (
                    <WebinarReportPresentation
                        connectionLink={connectionLink}
                        connectionId={connectionId}
                        cancelled={cancelled}
                        webinarReportsVM={webinarReportsVM}
                    />
                )}
                <DefaultButton
                    className='small-button silver-button'
                    disabled={!connectionLink || cancelled}
                    text={<FormattedMessage {...JOIN_AS_ATTENDEE} />}
                    onClick={() => onLinkClick(connectionLink)}
                />
            </div>
            <div className='connection-list__field'>{type} {labels.MEETING_ID()}:<br />
                <TextWithCopyBtn message={connectionId} handleCopyClick={onCopyBtnClick} />
            </div>
            {connectionPassword && <div className='connection-list__field'>{type} {labels.MEETING_PASSCODE()}:<br />
                    <TextWithCopyBtn message={connectionPassword} handleCopyClick={onCopyBtnClick} />
            </div>}
            {sip && <div className='connection-list__field'>{type} {labels.SIP()}:<br />
                <TextWithCopyBtn message={sip} handleCopyClick={onCopyBtnClick} />
            </div>}
            {connectionAccount && <div className='connection-list__field'>{type} {labels.ACCOUNT()}:<br />
                <TextWithCopyBtn message={connectionAccount} handleCopyClick={onCopyBtnClick} />
            </div>}
            {connectionLink && <div className='connection-list__field'>{type} {labels.LINK()}:<br />
                <TextWithCopyBtn message={connectionLink} handleCopyClick={onCopyBtnClick} />
            </div>}
            {registrationUrl && <div className='connection-list__field'>{type} {labels.REGISTRATION_LINK()}:<br />
                <TextWithCopyBtn message={registrationUrl} handleCopyClick={onCopyBtnClick} />
            </div>}
        </>
    );
};
